import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { fetchMaintenanceState, hasMaintenanceBypass } from '@/features/maintenance'
import { fetchSessionFromApi } from '@/shared/lib/auth/fetchSession'
import { AuthenticatedBootstrap } from '@/shared/providers/AuthenticatedBootstrap'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ location }) => {
    const [session, maintenance] = await Promise.all([
      fetchSessionFromApi(),
      fetchMaintenanceState()
    ])

    // A manutenção vem ANTES do guard de sessão: às 23h um aluno deslogado
    // precisa ver a tela de manutenção, não o login seguido dela. Admin e
    // gestor passam direto e continuam validando a plataforma fechada.
    if (maintenance?.active && !hasMaintenanceBypass(session)) {
      // Leva junto a rota pretendida: a sessão não é encerrada, e ao fim da
      // janela o aluno é devolvido exatamente onde estava.
      const from = encodeURIComponent(
        `${location.pathname}${location.searchStr ?? ''}`
      )
      throw redirect({ href: `/manutencao?from=${from}` })
    }

    if (!session?.user) {
      const callbackUrl = encodeURIComponent(
        `${location.pathname}${location.searchStr ?? ''}`
      )
      throw redirect({ href: `/?modal=sign-in&callbackUrl=${callbackUrl}` })
    }

    return { session }
  },
  component: AuthenticatedLayoutRoute
})

function AuthenticatedLayoutRoute() {
  return (
    <AuthenticatedBootstrap>
      <Outlet />
    </AuthenticatedBootstrap>
  )
}
